import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import config from "../../../config/config";
import { Badge } from "react-bootstrap";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import React, { useEffect, useState, useRef } from "react";
import { toastError, toastSuccess } from "../../../common/Toast";
import { checkUserPermission } from "../../../common/UserPermission";

const SearchableDropdown = ({ callback, searchItemInputRef }) => {
  // console.log(customerID, "<===customerId 1155");
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  const searchResultRef = useRef(null);
  // const navigate = Navigate()
  //const Clone = localStorage.getItem("Clone");
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showRefresh, setShowRefresh] = useState(false);
  const [runApi, setRunApi] = useState(false);
  const [cursor, setcursor] = useState(0);
  const [loadingImage, setLoadingImage] = useState(false);

  // handleChange-
  const handleChange = () => {};

  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Click outside to hide search results
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);
      setLoadingImage(true);
      await axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/itemsearchforinventorycount?searchparam=${inputValue}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationID}&itemsearchtype=&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response.data.ResponseData.length > 0) {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;
              console.log("suggestions ==>", data[0].QuickbookId);

              const itemarray = data[0].Itemnumber.split(",");
              if (data.length === 1 && itemarray.includes(inputValue)) {
                handleInputClick(
                  data[0].ItemId,
                  data[0].ItemName,
                  data[0].VariationName,
                  data[0].UnitPrice,
                  data[0].Itemquantity,
                  data[0].Description,
                  data[0].VariationId,
                  data[0].AttributeId,
                  data[0].Module,
                  data[0].CategoryID,
                  data[0].CategoryName,
                  data[0].CostPrice,
                  data[0].Itemnumber,
                  data[0].Allowaltdescription,
                  data[0].IsItemserialnumber,
                  data[0].VariationQuantity,
                  data[0].RecallPrice,
                  data[0].Tier1,
                  data[0].Tier2,
                  data[0].Tier3,
                  data[0].Tier4,
                  data[0].Tier5,
                  data[0].QuickbookId
                );
                // setTableData([...tableData,...data])
              } else {
                setSuggestions(data);
              }
            }
          }
          setShowRefresh(false);
        })

        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setShowRefresh(true);
    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleKeyDown = (e) => {
    // e.preventDefault()
    console.log("log : e.keyCode =>", e.keyCode, e.key, e.target.value);

    console.log(suggestions, cursor, "suggestionsaa");

    if (e.keyCode === 13 || e.key === "Enter") {
      const item = suggestions[cursor];
      console.log(item, "7744");

      handleInputClick(
        item.ItemId,
        item.ItemName,
        item.VariationName,
        item.UnitPrice,
        item.Itemquantity,
        item.Description,
        item.VariationId,
        item.AttributeId,
        item.Module,
        item.CategoryID,
        item.CategoryName,
        item.CostPrice,
        item.Itemnumber,
        item.Allowaltdescription,
        item.IsItemserialnumber,
        item.VariationQuantity,
        item.RecallPrice,
        item.Tier1,
        item.Tier2,
        item.Tier3,
        item.Tier4,
        item.Tier5,
        item.QuickbookId
      );
    } else if (e.keyCode === 38 && cursor > 0) {
      setcursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
      setcursor(cursor + 1);
    }

    // setTimeout(()=>{
    //   barcodeScan=""
    // },100)
  };

  // const handleToast = () => {
  //   if (readonly === true) {
  //     toastError("Please Select a Customer First");
  //   }
  // };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pCostPrice,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pRecallPrice,
    pTier1,
    pTier2,
    pTier3,
    pTier4,
    pTier5,
    pQuickbookId

    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {});

            let tablesDatas = data.map((item) => ({
              SaleItemID: 0,
              ItemId: item.ItemId,
              SaleId: 0,
              UnitPrice: item.UnitPrice,
              // Price: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: item.VariationQuantity,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              ActualOnHand: parseInt(item.VariationQuantity),
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              CostPrice: item.CostPrice,
              Itemnumber: item.Itemnumber,
              Total: item.UnitPrice,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
            }));

            setTableData([tablesDatas[0]]);
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        SaleItemID: 0,
        ItemId: pItemId,
        SaleId: 0,
        UnitPrice: pUnitPrice,
        // Price: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: pItemQuantity,
        ItemCurrentQuantity: pItemQuantity, //pItemQuantity,
        ActualOnHand: parseInt(pItemQuantity),
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        CostPrice: pCostPrice,
        Itemnumber: pItemnumber,
        Total: pUnitPrice,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        RecallPrice: pRecallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        QuickbookId: pQuickbookId,
        // ItemKitId: pItemId
      };
      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);
  console.log(suggestions, "<========suggestions");

  return (
    <div className="container">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              {showRefresh ? (
                <i
                  style={{ color: "#FF9F43" }}
                  class="fa fa-refresh fa-spin"
                ></i>
              ) : (
                <Link to="/manage-items">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </Link>
              )}
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              ref={searchItemInputRef}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div ref={searchResultRef} className="dropdown">
            <ul
              className="dropdown-menu w-100 show"
              style={{ "max-height": "500px", overflow: "auto" }}
            >
              {suggestions.map((item, index) => (
                <li
                  className="border-bottom"
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.CostPrice,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity,
                      item.RecallPrice,
                      item.Tier1,
                      item.Tier2,
                      item.Tier3,
                      item.Tier4,
                      item.Tier5,
                      item.QuickbookId

                      // item.ItemKitId
                    )
                  }
                >
                  <Link
                    key={item.ItemId}
                    href="#"
                    // className="dropdown-item"
                    className={
                      cursor === index
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    data-name={item.ItemName?.toLowerCase()}
                  >
                    <img
                      src={item.ImageName}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle m-2"
                      width="55"
                      height="55"
                    />

                    <div className="customer-info">
                      <strong className="name word-break-data">
                        {item.ItemName}{" "}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                        <Badge
                          className="ml-auto"
                          variant="primary"
                          style={{ position: "absolute", right: "5px" }}
                        >
                          {item.Module}
                        </Badge>
                      </strong>
                      <div>
                        {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                        Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                        {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                        Selling Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.Itemquantity)}
                      </div>
                      <div>Categories: {item.CategoryName}</div>
                      {/* Add any other customer details here */}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
};
const ItemQantity = (props) => {
  const paramObject = useParams();
  const qtyInputRef = useRef(null);
  const searchItemInputRef = useRef(null);
  const Id = localStorage.getItem("ID");
  const [stateNew, setStateNew] = useState([]);
  const [QbData, setQbData] = useState([]);
  const [IsQbview, setIsQbview] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleitemqty = () => {
    let QuickbookIdstr = "";

    QuickbookIdstr = stateNew.map(
      (item) => `'${item?.QuickbookId == null ? 0 : item?.QuickbookId}'`
    );
    console.log(QuickbookIdstr, "logcount");

    let reqobj = {
      loginuserid: Id,
      QuickbookIdstr: QuickbookIdstr,
    };

    setLoading(true);
    axios
      .post(`${config.itemsBaseUrl}/items/ItemQtyVerify`, reqobj)
      .then((res) => {
        setLoading(false);

        console.log(res.data.ResponseData, "4444444");
        setQbData(res.data.ResponseData);
        setIsQbview(true);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err, "88778");
        toastError(err.response.data);
        return 0;
      });
  };

  const ClearData = () => {
    localStorage.removeItem("QbData");
    setStateNew([]);
    window.location.reload();
  };

  const callback = (payload) => {
    console.log(payload, "410501");

    if (payload != undefined && payload.length > 0) {
      let newItem = { ...payload[payload.length - 1] };

      const existingItemIndex = stateNew.findIndex(
        (item) =>
          item.ItemId === newItem.ItemId &&
          item.VariationId === newItem.VariationId
      );
      if (existingItemIndex == -1) {
        let value = [newItem, ...stateNew];
        setStateNew(value);
        localStorage.setItem("QbData", JSON.stringify(value));
        setTimeout(() => {
          if (qtyInputRef.current) {
            qtyInputRef.current.focus();
            qtyInputRef.current.select();
          }
        }, 0);
      }
    }
    // setStateNew(payload);
  };

  const handleDeletePopup = (index) => {
    const updateddata = [...stateNew];
    updateddata.splice(index, 1);
    setStateNew(updateddata);
  };

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("QbData"));
    if (data) {
      setStateNew(data);
    }
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Count Inventory</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-12 page-button mb-3">
            {paramObject.id > 0 && (
              <div className="p-2">
                <button
                  className="btn btn-secondary "
                  onClick={() => navigate(-1)}
                  disabled={stateNew?.length === 0}
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="card">
          {/* Card Header {Count Inventory} */}
          <div className="card-header">
            <div className="row">
              <div className="col-md-6">
                {/* <h5 className="fw-bold mt-3">New Inventory Count</h5> */}
                <div className="col-md-12">
                  <div className="input-group flex-nowrap col-md-8">
                    <SearchableDropdown
                      callback={callback}
                      searchItemInputRef={searchItemInputRef}
                    />
                    {/* <Link className="btn btn-info" to="#">
                          Search
                        </Link> */}
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                {checkUserPermission("Fetch_qb-qty") ? (
                  <button
                    className="btn btn-secondary "
                    onClick={handleitemqty}
                  >
                    Fetch QB & DB Qty
                  </button>
                ) : (
                  " "
                )}
              </div>

              <div className="col-md-1">
                <button className="btn btn-secondary " onClick={ClearData}>
                  Clear data
                </button>
              </div>
            </div>
          </div>
        </div>

        {!IsQbview ? (
          <div className="card">
            <div className="card-body">
              <table className="table table-striped custom-table">
                <thead>
                  <tr>
                    <th className="p-regular">Sr.No</th>
                    <th className="p-regular">Item No</th>
                   <th className="p-regular"> Item Name </th>
                    <th className="p-regular">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {stateNew?.map((data, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <td>{index + 1} </td>
                          <td>{data.ItemId}</td>

                          <td>
                            {data?.VariationName == ""
                              ? data?.ItemName
                              : data?.VariationName}{"   "}
                            {data?.QuickbookId > 0 ? (
                              <i
                                className="fa fa-circle"
                                style={{ fontSize: "15px", color: "green" }}
                              ></i>
                            ) : (
                              <i
                                className="fa fa-circle"
                                style={{ fontSize: "15px", color: "red" }}
                              ></i>
                            )}
                          </td>

                          <td>
                            <Link
                              className="confirm-text"
                              to="#"
                              title="Delete"
                              // data-bs-toggle="modal"
                              // data-bs-target="#DeleteConfirmationModal"
                              onClick={() => handleDeletePopup(index)}
                            >
                              <i
                                className="fa fa-trash text-red fa-2x"
                                data-bs-toggle="tooltip"
                                title="Delete"
                              ></i>
                            </Link>
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <> </>
        )}

        {IsQbview ? (
          <div className="card">
            <div className="card-body">
              <table className="table table-striped custom-table">
                <thead>
                  <tr>
                    <th className="p-regular">ItemId</th>
                    <th className="p-regular">QuickbookId</th>
                    <th className="p-regular">Item Name</th>
                    <th className="p-regular">SaleCount</th>
                    <th className="p-regular">ReceivingCount</th>
                    <th className="p-regular">InventoryAdjument</th>
                    <th className="p-regular">POSQuantity</th>
                    <th className="p-regular">QBQtyOnHand</th>
                    <th className="p-regular"> Detil Report </th>
                  </tr>
                </thead>
                <tbody>
                  {QbData?.map((data, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <td>{data?.ItemId} </td>
                          <td>{data.QuickbookId}</td>
                          <td>{data?.Name} </td>
                          <td>{Number(data.SaleCount).toFixed(2)}</td>
                          <td>{Number(data?.ReceivingCount).toFixed(2)} </td>
                          <td>{Number(data.InventoryAdjument).toFixed(2)}</td>
                          <td>{Number(data?.POSQuantity).toFixed(2)} </td>
                          <td>{Number(data.QBQtyOnHand).toFixed(2)}</td>

                          <td>
                            <button
                              className="btn btn-primary"
                              title="Delete"
                              // data-bs-toggle="modal"
                              // data-bs-target="#DeleteConfirmationModal"
                              onClick={() =>
                                navigate(
                                  `/ItemDetilQtyReport?ID=${data.ItemId}`
                                )
                              }
                            >
                              Get Data
                            </button>
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <> </>
        )}
      </div>
    </>
  );
};

export default ItemQantity;
